export default __webpack_public_path__ + "static/media/move-arte-5.99246d3e.webp";